import {
  actions,
} from '../reducer';

import {
  fetchInitiatives,
} from './api.service';

const {
  getInitiativesRequest,
  getInitiativesSuccess,
  getInitiativesFailure,
  setInitiativeId,
} = actions;

export const setInitiative = (initiativeId) => async (dispatch) => {
  try {
    sessionStorage.setItem('initiative_id', initiativeId);
    dispatch(setInitiativeId({ initiativeId: String(initiativeId) }));
  } catch ({ message }) {
    console.log(message);
  }
};

export const fetchInitiativesForSelect = (id) => async (dispatch, getState) => {
  try {
    dispatch(getInitiativesRequest());
    const { data } = await fetchInitiatives({ perPage: 999, page: 1 });
    dispatch(getInitiativesSuccess({
      initiatives: data.data,
    }));
    const { initiativeId } = getState().globalSelections;
    if (id && String(id) !== String(initiativeId)) {
      dispatch(setInitiative(id));
    }
  } catch ({ message }) {
    dispatch(getInitiativesFailure(message));
  }
};
